
import { FetchGet, FetchPost } from "./fetch";

export function ApiGetTuShopsList(params) {
    return FetchGet('/tuShopsList', params);
}
export function ApiGetTuImageList(params) {
    return FetchGet('/tuImageList', params);
}
export function ApiGetTuImageTagList(params) {
    return FetchGet('/tuImageTagList', params);
}
export function ApiPostTuImageTagAdd(data) {
    return FetchPost('/tuImageTagAdd', data);
}
export function ApiPostTuImageTagEdit(data) {
    return FetchPost('/tuImageTagEdit', data);
}
export function ApiGetTuImageTagDel(data) {
    return FetchGet('/tuImageTagDel', data);
}

export function ApiGetTuBigImageApi(params) {
    return FetchGet("/tuBigImage", params);
}
// 当前登录用户信息
export function ApiGetcurrentUserApi() {
    return FetchGet("/currentUser");
}